// extracted by mini-css-extract-plugin
module.exports = {"root":"ManageBrandProductCategories_root__DVJD1","header":"ManageBrandProductCategories_header__3YEoW"};